/*

	お問い合わせ一覧画面

*/
import ApplicationTemplate from "common/layouts/application"
import Provider from "./hooks"

export default function List() {
  return (
    <ApplicationTemplate>
      <Provider />
    </ApplicationTemplate>
  )
}
